import { Component, OnInit, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { of } from "rxjs";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { CnpjAssociadoAgenteFinanceiroSCR } from "src/app/model/cnpj-associado-agente-financeiro-scr.model";
import Utils from "src/app/shared/fgi-utils";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { PermissaoService } from "src/app/shared/permissao.service";
import { AgenteFinanceiroService } from "src/app/shared/services/agente-financeiro.service";
import { IntegracaoService } from "../integracao.service";
import { NgbNavChangeEvent, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalCadastroScrAssociados } from "./modal-cadastro-scr-associados/modal-cadastro-scr-associados.component";
import { MensagemService } from "../../mensagem.service";

@Component({
    templateUrl: 'scr-associados-pesquisa.component.html',
    standalone: false
})
export class ScrAssociadosPesquisaComponent implements OnInit {

    private atributosPaginacaoComponenteListagem: EntityPagedResult<CnpjAssociadoAgenteFinanceiroSCR>;
    private opcoesPaginacao:number[];
    public associados:CnpjAssociadoAgenteFinanceiroSCR[];
    public pesquisaForm:UntypedFormGroup;
    public podeEnviarScr: boolean = false;
    public pesquisado: boolean = false;
    public esconderPesquisa: boolean = true;
    public agentesFinanceiros:AgenteFinanceiro[];

    constructor(
        private integracaoService:IntegracaoService,
        private formBuilder:UntypedFormBuilder,
        private loadingService:BnLoadingService,
        private permissaoService: PermissaoService,
        private activatedRoute:ActivatedRoute,
        private agenteService: AgenteFinanceiroService,
        private fileUtils:FileUtilsService,
        private abrirModal: NgbModal, //criado para abrir as modais das abas
        private mensagemService: MensagemService,

        ){
        
        this.buscarAgentesFinanceiros();
            
        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };

        this.pesquisaForm = this.formBuilder.group({
            agenteFinanceiro:null,
            cnpjAssociado: null
        });
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscar();
    }
    
    ngOnInit(): void {
        
       this.permissaoService
           .getPermissoesUsuarioAutenticado()
           .subscribe((resp: any) => {
            this.podeEnviarScr = resp && resp[ROLE_GESTOR_ENVIO]});
    }

    limpar(){

        this.pesquisaForm.setValue({
            agenteFinanceiro:null,
            cnpjAssociado: null
        });

        this.associados = [];
        this.pesquisado = false;
        this.atributosPaginacaoComponenteListagem.page = 1;
    }

    mudancaPagina(novaPagina: EntityPagedResult<CnpjAssociadoAgenteFinanceiroSCR>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.esconderPesquisa = true;
        this.buscar();
    }
    
    exportarAssociados(){
        const params = this.tratarParams();
        const associados$ = this.integracaoService.getScrsAssociados(params);
        this.loadingService.bloqueiaTela();
        const liberaTela = ()=>this.loadingService.liberaTela();
        
        associados$.subscribe(resp=>{
            let conteudoCsv = "CNPJ;SIGLA;NOME AGENTE FINANCEIRO;CNPJ ASSOCIADO;NOME AGENTE ASSOCIADO";
            
            let bodyCsv = of(
                resp?.resultados?.map(associado => {
                    return `${this.retornaCnpjPorIdAssociado(associado.agenteFinanceiro)+ "\t"};${this.retornaSiglaPorIdAgente(associado.agenteFinanceiro)};${this.nomeAgenteFinanceiroPorId(associado.agenteFinanceiro)};${associado.cnpjAssociado + "\t"};${associado.nomeRazaoSocialAssociado}`;
                })
            );

            bodyCsv.subscribe(associados=>{
                associados.forEach(linha => {
                    conteudoCsv += '\n'+linha;
                });
                this.fileUtils.exportarArquivo("associados.csv","\ufeff"+conteudoCsv, FileUtilsService.TEXT_CSV);
            });

        },
        liberaTela,
        liberaTela);

    }

    retornaSiglaPorIdAgente(id):string{ 
        return this.agentesFinanceiros.filter(e=>e.id==id)[0].sigla;
    }
    
    retornaCnpjPorIdAssociado(id):string{ 
        return this.agentesFinanceiros.filter(e=>e.id==id)[0].cnpj
    }
    
    nomeAgenteFinanceiroPorId(id:number){
        return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
    }

    tratarParams():any{
        const params:any = {};
        const dadoFormulario = this.pesquisaForm.getRawValue();

        if (dadoFormulario.agenteFinanceiro) {
            params.agenteFinanceiro = dadoFormulario.agenteFinanceiro;
        }
        if (dadoFormulario.cnpjAssociado) {
            params.cnpjAssociado = this.tratarCNPJ(dadoFormulario.cnpjAssociado);
        }

        return params;
    }

    tratarCNPJ(cnpj: string):any{
        if (cnpj) {
            const regex = /\.|\/|\/|\-|\s/;
            let a: string = cnpj;
            const max = a.length;
            for (let i = 0; i < max; i++) {
                a = a.replace(regex, "");
            }
            cnpj = a.trim();
        }

        return cnpj;
    }

    buscar(){

        const params = this.tratarParams();
        
        if(!this.esconderPesquisa){
            this.atributosPaginacaoComponenteListagem.page = 1;
        }
        params.pagina = this.atributosPaginacaoComponenteListagem.page;
        params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
        this.loadingService.bloqueiaTela();
        this.integracaoService.getScrsAssociados(params).subscribe(response => {
            this.associados = response ? response.resultados : undefined;
            this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
            this.loadingService.liberaTela();
            this.pesquisado = true;
            this.esconderPesquisa = false
        },
        ()=>this.loadingService.liberaTela());
    }
    public buscarAgentesFinanceiros(){
    this.integracaoService.getAgentesAssociados().subscribe(resp=>{
        this.agentesFinanceiros = resp;
        
    });

}

    public abrirModalCadastro() {
        const modalRef: NgbModalRef = this.abrirModal.open(ModalCadastroScrAssociados);
        modalRef.result.then((resultado) => {
            if (resultado.botao == "salvar") {
                this.loadingService.bloqueiaTela();
                resultado.valor.cnpjAssociado = this.tratarCNPJ(resultado.valor.cnpjAssociado);
                this.integracaoService.cadastrarScrAssociado(resultado.valor).subscribe(t => {
                    if(this.pesquisado) this.buscar();
                    this.buscarAgentesFinanceiros();
                    this.mensagemService.adicionarMensagemSucesso("O Cnpj Associado, número: "+ t.cnpjAssociado +" , inserido com sucesso!");
                }
                )
                this.loadingService.liberaTela();
            }
        },
        ()=>this.loadingService.liberaTela());
    }
      
    }